export const capitalize = value =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()

export const isString = value => typeof value === 'string'
